const PHRASES = ["Taste That Gets Remembered", "Pure Vegetarian", "25+ Years of Craft", "The Taste You Want"];

export const Marquee = () => {
  const row = [...PHRASES, ...PHRASES, ...PHRASES];
  return (
    <div data-testid="editorial-marquee" className="bg-gold py-5 overflow-hidden border-y border-espresso/10">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((p, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className={`font-serif italic text-2xl md:text-4xl text-espresso px-6 ${i % 2 ? "font-light" : ""}`}>{p}</span>
                <span className="text-espresso/40 text-xl">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
